<div class="loading">
  <div class="bz-env-loading">
    <bzg-loading [size]="'m'" ></bzg-loading>
  </div>
  <div class="loading__tittle">
    <span *ngIf="messageType === 0">{{'MAINTENANCE.STARTED_MAINTENANCE' | translate}}</span>
    <span *ngIf="messageType === 1">{{'MAINTENANCE.STOPPING_MAINTENANCE' | translate}}</span>
    <span *ngIf="messageType === 2">{{'MAINTENANCE.RESTARTING_SERVICE' | translate}}</span>
  </div>
</div>
